import { CDN_PIVOT } from 'core/constants/endpoints'
import getById from 'utils/DOM/getById'
import toggleClass from 'utils/DOM/toggleClass'

const specificStates = [
  'AZ',
  'IL',
  'LA',
  'MI',
  'MO',
  'MT',
  'NC',
  'NE',
  'NM',
  'NV',
  'OK',
  'SC',
  'SD',
  'TN',
  'TX',
  'GA',
  'OH',
  'PA',
  'KS'
]

function setOOCDisclaimer(state) {
  const isSpecificState = specificStates.includes(state)
  let documentKey = state.toLowerCase()

  if (!isSpecificState) {
    documentKey = 'generic'
  }

  const link = `${CDN_PIVOT}/resources/v2/products/fbm/documents/outline-of-coverage/${documentKey}/${documentKey}-outline-of-coverage.pdf`
  const element = getById('disclaimer-ooc')

  if (element) {
    element.firstChild.href = link
    toggleClass(element, 'd-flex')
    toggleClass(element, 'd-none', false)
  }
}

export default setOOCDisclaimer
